import React from "react";
import { Box } from "@mui/system";
import { useBackButtonSX } from "../../hooks/use-backButtonSX";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router";

export const BackButton = () => {
  const backButtonSX = useBackButtonSX();
  const navigate = useNavigate();
  return (
    <Box sx={{ ...backButtonSX }}>
      <Typography
        variant="body2"
        sx={{
          cursor: "pointer",
          fontFamily: "IRANSansX",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => navigate(-1)}
      >
        → بازگشت
      </Typography>
    </Box>
  );
};
